<template>
<div class="site-toolbar">
    <div class="items toolbar-service">
        <i class="iconfont icon-kefu"></i>
        <span @click="ServiceTo">联系客服</span>
    </div>
    <div class="toolbar-item">
        <div class="items">
            <i class="iconfont icon-phone"></i>
            <span>联系电话</span>
            <div class="phone">400-000-5784 <!--<em class="rest">腊月廿八-正月初六（休息）</em>--></div>
        </div>
        <div class="items">
            <i class="iconfont icon-weixin"></i>
            <span>官方微信</span>
            <div class="wxchat"><img src="./images/wxcode.jpg" alt="官方微信"></div>
        </div>
        <div class="items">
            <i class="iconfont icon-gotop"></i>
            <span @click="scrollTo">回到顶部</span>
        </div>
    </div>
</div>
</template>
<script>
import {goTop} from 'src/assets/js/dom'
    export default {
        methods: {
            ServiceTo() {
                ysf.open({
                    templateId: 2479658
                })
            },
            scrollTo(){
                goTop(0)
            }

        }
    }
</script>
<style lang="scss" scoped>
    .site-toolbar {
        position: fixed;
        right: 6px;
        bottom: 200px;
        width: 60px;
        font-size: 12px;
        z-index: 8;
        span {
            display: none;
            line-height: 15px;
        }
    }

    .items {
        position: relative;
        display: block;
        padding: 14px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #fff;
        cursor: pointer;
        &:hover {
            .iconfont {
                display: none;
            }
        }
    }

    .toolbar-service {
        background: #1879c5;
        border-radius: 4px;
        .iconfont {
            color: #fff;
            font-size: 34px;
        }
        &:hover span {
            display: block;
            color: #fff;
        }
    }

    .toolbar-item {
        margin-top: 5px;
        border: 1px solid #ddd;
        border-radius: 4px;
        .iconfont {
            color: #bfbfbf;
            font-size: 30px;
        }
        .phone {
            position: absolute;
            left: 0;
            top: -1px;
            width: 0;
            height: 58px;
            // padding-top:10px;
            // line-height: 28px;
            line-height: 58px;
            background: #fff;
            text-align: center;
            font-size: 16px;
            color: #888;
            transition: width 0.5s, left 0.5s;
            overflow: hidden;
            // .rest{
            //     display: block;
            //     font-size:12px;
            //     line-height: 12px;
            //     transform: scale(0.9);
            // }
        }
        .wxchat {
            position: absolute;
            left: -179px;
            top: -60px;
            opacity: 0;
            width: 176px;
            height: 176px;
            background: #fff;
            border: 1px solid #ddd;
            border-radius: 4px;
            transform-origin: 100% 95%;
            transform: scale(.1);
            transition: opacity .25s, transform .3s;
            img {
                width: 176px;
                height: 176px;
            }
        }
        .items {
            &:first-child {
                border-bottom: 1px solid #edf0f5;
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
            }
            &:last-child {
                border-top: 1px solid #edf0f5;
                border-bottom-left-radius: 4px;
                border-bottom-right-radius: 4px;
            }
            &:hover {
                .phone {
                    left: -161px;
                    width: 158px;
                    border: 1px solid #ddd;
                }
                .wxchat {
                    transform: scale(1);
                    opacity: 1;
                }
                span {
                    display: block;
                    color: #2996eb;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/service/index.vue